const namespace = 'school-search/';

export const SCHOOLS_LOAD_REQUEST = `${namespace}SCHOOLS_LOAD_REQUEST`;
export const SCHOOLS_LOAD_SUCCESS = `${namespace}SCHOOLS_LOAD_SUCCESS`;
export const SCHOOLS_LOAD_FAILURE = `${namespace}SCHOOLS_LOAD_FAILURE`;

export const SCHOOL_SEARCH_LOAD_SUCCESS = `${namespace}SCHOOL_SEARCH_LOAD_SUCCESS`;
export const SCHOOL_SEARCH_LOAD_FAILURE = `${namespace}SCHOOL_SEARCH_LOAD_FAILURE`;

export const INITIALIZE_USER_SCHOOL_UPDATE_REQUEST = `${namespace}INITIALIZE_USER_SCHOOL_UPDATE_REQUEST`;
